import { memo } from 'react';
import type { PreisToolItem } from '@/api/preis-tool/preis-tool.types';
import { computeBedarf } from '../../helpers';

export const BedarfCell = memo(function BedarfCell({ item }: { item: PreisToolItem }) {
  const bedarf = computeBedarf(item);
  return (
    <span style={{
      color: bedarf > 0 ? 'var(--warn)' : 'var(--ink-3)',
      fontWeight: bedarf > 0 ? 600 : 400,
    }}>
      {bedarf > 0 ? bedarf : '—'}
    </span>
  );
});
